import { store } from 'redux/store'

export function getLocalized(item, property) {
  const local = store.getState().language.local
  if (!item) {
    return ''
  }
  return item[`${property}_${local}`]
}
